import { defineAsyncComponent } from 'vue';

export const marginAndMarkupSettingsFrontends = {
	MarginAndMarkupSettingsPage: defineAsyncComponent(
		() => import('./components/MarginAndMarkupSettingsPage.vue')
	),
};
